const LandingPage = () => import('@/views/LandingPage/LandingPage.vue');
const LandingPageIFrame = () => import('@/views/LandingPageIFrame/LandingPageIFrame.vue');

export const localizedLandingPagesPaths = {
  de: '/de/insertion/inserat-online-erfassen',
  fr: '/fr/insertion/publier-soi-meme-en-ligne',
  it: '/it/insertion/inserire-in-linea',
  en: '/en/insertion/submit-ad-online',
};

export default [
  ...Object.entries(localizedLandingPagesPaths).map(([locale, path]) => ({
    path: path,
    name: `landingpage-${locale}`,
    component: LandingPage,
    meta: {
      viewName: 'Insertion Landing Page',
      locale,
      ssgPrerendered: true,
    },
  })),
  {
    path: '/:locale/insertion/landingpage-iframe',
    name: 'landingpage-iframe',
    component: LandingPageIFrame,
  },
];
